import { storeToRefs } from 'pinia';
import { isGuaranteeActionBeingClickedStore } from '~/stores/isGuaranteeActionBeingClicked';

export default function () {

  const store = isGuaranteeActionBeingClickedStore();
  const { isGuaranteeActionBeingClicked } = storeToRefs(store);

  return {
    ...store,
    isGuaranteeActionBeingClicked,
  };

}